import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printNonFormularyRequest } from './printNonFormularyRequest';

export default {
    name: 'NonFormularyRequests',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewNonFormularyRequestsUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.isFacilityUser) {
            this.loadProducts();
        }
    },

    computed: {
        isMinistryUser() {
            return this.canReviewProcurementRequestsUi();
        },
        isFacilityUser() {
            return this.canCreateNonFormularyRequestsUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي الطلبات', this.pages, 'primary', 'ti ti-list-details'),
                this.statCard('طلبات مرسلة', this.countWhere(this.Info, item => this.matchStatus(item, [2], ['مرسل'])), 'warning', 'ti ti-send'),
                this.statCard('طلبات معتمدة', this.countWhere(this.Info, item => this.matchStatus(item, [3], ['معتمد'])), 'success', 'ti ti-circle-check'),
                this.statCard('طلبات مرفوضة', this.countWhere(this.Info, item => this.matchStatus(item, [4], ['مرفوض'])), 'danger', 'ti ti-ban'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            reviewDialog: false,
            products: [],
            createForm: {
                requestedProductName: '',
                productsId: null,
                justification: ''
            },
            reviewForm: {
                id: 0,
                approve: true,
                ministryNote: ''
            }
        };
    },

    methods: {
        statusBadgeClass(status) {
            const normalizedStatus = Number(status);
            if (normalizedStatus === 3) return 'bg-label-success';
            if (normalizedStatus === 4) return 'bg-label-danger';
            if (normalizedStatus === 2) return 'bg-label-warning';
            return 'bg-label-secondary';
        },
        statusLabel(status) {
            const normalizedStatus = Number(status);
            if (normalizedStatus === 2) return 'مرسل';
            if (normalizedStatus === 3) return 'معتمد';
            if (normalizedStatus === 4) return 'مرفوض';
            return '-';
        },
        requestCode(item) {
            if (!item) return '-';
            return item.code || item.requestCode || `NF-${item.id}`;
        },
        requestName(item) {
            if (!item) return '-';
            return item.requestedProductName || item.productName || '-';
        },
        requestMetaText(item) {
            if (!item) return 'بدون مبرر مرفق';
            return item.justification || 'بدون مبرر مرفق';
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetNonFormularyRequests(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        loadProducts() {
            this.$http.GetAllProducts()
                .then((response) => {
                    this.products = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.products = [];
                });
        },
        openCreateDialog() {
            this.createForm = {
                requestedProductName: '',
                productsId: null,
                justification: ''
            };
            this.createDialog = true;
        },
        onProductChange() {
            const row = (this.products || []).find((x) => Number(x.id) === Number(this.createForm.productsId));
            if (row && !this.createForm.requestedProductName) {
                this.createForm.requestedProductName = row.name;
            }
        },
        submitCreate() {
            if (!this.createForm.justification || (!this.createForm.productsId && !this.createForm.requestedProductName)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أدخل الصنف أو اسمه وسبب الطلب.');
                return;
            }
            this.$blockUI.Start();
            this.$http.CreateNonFormularyRequest(this.createForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data.message || 'تم إرسال الطلب.');
                    this.createDialog = false;
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetNonFormularyRequest(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openReview(approve) {
            if (!this.detail) return;
            this.reviewForm = {
                id: this.detail.id,
                approve,
                ministryNote: ''
            };
            this.reviewDialog = true;
        },
        submitReview() {
            this.$blockUI.Start();
            this.$http.ReviewNonFormularyRequest(this.reviewForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.reviewDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkNonFormularyRequestPrinted(this.detail.id)
                .then(() => {
                    const opened = printNonFormularyRequest(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        decisionBadgeClass(decision) {
            if (decision === 2) return 'bg-label-success';
            if (decision === 3) return 'bg-label-danger';
            return 'bg-label-warning';
        }
    }
};
